import { SelectOption } from 'carrier-fe';
import ViessmannGas from 'carrier-fe/src/images/viessmann_gas.jpg';
import ViessmannHeatpumps from 'carrier-fe/src/images/viessmann_heatpumps.jpg';
import ViessmannElectric from 'carrier-fe/src/images/viessmann_electric.png';
import ViessmannSolar from 'carrier-fe/src/images/viessmann_solar.jpg';

export const DEFAULT_NAVIGATION_GUARD =
   'Are you sure you want to leave this page? You will lose any unsaved changes for the current step.' as const;

export enum STEPS {
   STEP_1 = 1,
   STEP_2 = 2,
   STEP_3 = 3,
   STEP_4 = 4,
   STEP_5 = 5,
   STEP_6 = 6,
}

export const TOTAL_STEPS = 6 as const;

export const MAX_APPLIANCES = 10 as const;

export const TEN_MINUTES = 10 / (24 * 60);

export enum QUERY_KEYS {
   PROPERTY_TYPES = 'property_types',
   CONTACT_TITLES = 'contact_titles',
   CONTACT_TYPES = 'contact_types',
   WORK_CATEGORIES = 'work_categories',
   PRODUCT_LOCATIONS = 'product_locations',
   MERCHANTS = 'merchants',
   CUSTOMERS = 'customer_companies',
   INSTALLER_USERS = 'installer_users',
   INSTALLER_COMPANIES = 'installer_companies',
}

export enum SYSTEM_TYPES {
   GAS_BOILER = 'gas_boiler',
   HEAT_PUMPS = 'heat_pump',
   SOLAR = 'solar',
   ELECTRIC_BOILER = 'electric_boiler',
}

export enum STATUS_TYPES {
   COMPLETED = 'completed',
   IN_PROGRESS = 'in_progress',
   CANCELLED = 'cancelled',
}

export enum MERCHANT_IDS {
   OTHER = 'other',
}

export const SYSTEM_TYPES_OPTIONS = [
   {
      value: SYSTEM_TYPES.GAS_BOILER,
      label: 'Gas Boiler',
      imageSrc: ViessmannGas,
   },
   {
      value: SYSTEM_TYPES.HEAT_PUMPS,
      label: 'Heat Pumps',
      imageSrc: ViessmannHeatpumps,
   },
   {
      value: SYSTEM_TYPES.SOLAR,
      label: 'Solar',
      imageSrc: ViessmannSolar,
   },
   {
      value: SYSTEM_TYPES.ELECTRIC_BOILER,
      label: 'Electric Boiler',
      imageSrc: ViessmannElectric,
   },
];

export enum REGISTERING_PARTIES {
   HOUSEHOLDER = 'householder',
   HOUSEHOLDER_LABEL = 'Householder - Register warranty only',
   INSTALLER_LABEL = 'Installer - Register warranty only',
   INSTALLER = 'installer',
   INSTALLER_VPLUS_LABEL = 'Installer - register via VPlus. See Benefits'
}
